import { startsWith } from 'lodash';
import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import AccountPoolsAction from '../actions/AccountPoolsActionCreator';
import AccountsActionCreator from '../actions/AccountsActionCreator';
import InternetBankingActions from '../actions/InternetBankingActions';
const getAccountPoolEndPoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/pools';
const createAccountPoolEndPoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/pools';
const getAccountsEndpoint = '/ibapi/v2/banks/{bank-id}/accounts/default';
const updateAccountPoolEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/pools/{pool-id}';
const deleteAccountPool = '/ibapi/v2/banks/{bank-id}/accounts/default/pools/';
const getSpecificPoolDetail =
  '/ibapi/v2/banks/{bank-id}/accounts/default/pools/';
const exportTransactions =
  '/ibapi/v2/banks/{bank-id}/accounts/default/statement/file';

class AccountPoolsApiUtils {
  /*
   ** api call to get account pools
   */
  static getAccountPools() {
    const url = envConfig.isStubsEnabled
      ? `${envConfig.apiBaseUrlStub}${getAccountPoolEndPoint}`
      : `${envConfig.apiBaseUrlPAAS}${getAccountPoolEndPoint}`;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.accountService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        AccountPoolsAction.getAccountPoolsSuccess(body);
      },
      (error) => {
        AccountPoolsAction.getAccountPoolsFailure(error);
      }
    );
  }

  static createAccountPool(request) {
    let url = envConfig.isStubsEnabled
      ? `${envConfig.apiBaseUrlStub}${createAccountPoolEndPoint}`
      : `${envConfig.apiBaseUrlPAAS}${createAccountPoolEndPoint}`;
    const requestData = JSON.stringify(request);
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.accountService,
        method: 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        AccountPoolsAction.createAccountPoolSuccess(body);
      },
      (error) => {
        AccountPoolsAction.createAccountPoolFailure(error);
      }
    );
  }

  static getAccountsList() {
    let url = envConfig.isStubsEnabled
      ? `${envConfig.apiBaseUrlStub}${getAccountsEndpoint}`
      : `${envConfig.apiBaseUrlPAAS}${getAccountsEndpoint}`;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.timelineService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body, status) => {
        AccountPoolsAction.getAccountListSuccess(body);
      },
      (error, status) => {
        if (
          status === 401 &&
          startsWith(
            error.headers[config.authenticateHeaderName],
            'Bearer realm error=tsandcs'
          )
        ) {
          setTimeout(() => {
            this.getAccountsList();
          }, 5000);
        } else if (status === 403) {
          InternetBankingActions.navigateToWebTask('WEB-NONBCUSTOMERERROR');
        } else {
          AccountsActionCreator.handleAccountsListError(error, status);
        }
      }
    );
  }

  static updateAccountPool(poolId, request) {
    let url = envConfig.isStubsEnabled
      ? `${envConfig.apiBaseUrlStub}${updateAccountPoolEndpoint}`
      : `${envConfig.apiBaseUrlPAAS}${updateAccountPoolEndpoint}`;
    url = url.replace('{pool-id}', poolId);
    const requestData = JSON.stringify(request);
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.timelineService,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        AccountPoolsAction.updateAccountPoolSuccess(body);
      },
      (error) => {
        AccountPoolsAction.updateAccountPoolFailure(error);
      }
    );
  }
  static deleteAccountPool(poolId) {
    const url = `${envConfig.apiBaseUrlPAAS}${deleteAccountPool}${poolId}`;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.accountService,
        method: 'DELETE',
        url,
        addAuthToken: true,
      },
      (body) => {
        InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-POOLS');
      },
      (error) => {
        InternetBankingActions.navigateToWebTask('WEB-ACCOUNT-POOLS');
      }
    );
  }
  static getSpecificPoolDetail(poolId) {
    const url = `${envConfig.apiBaseUrlPAAS}${getSpecificPoolDetail}${poolId}`;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.accountService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        AccountPoolsAction.getSpecificPoolDetailsSuccess(body);
      },
      (error) => {
        AccountPoolsAction.getSpecificPoolFailure(error);
      }
    );
  }

  static exportTrasnactions(requestPayload, success, error) {
    const url = `${envConfig.apiBaseUrlPAAS}${exportTransactions}`;
    ApiUtils.makeRequest(
      {
        url,
        method: 'POST',
        apiVersion: config.apiVersions.transactionsExport,
        requestData: requestPayload,
      },
      success,
      error
    );
  }
}

export default AccountPoolsApiUtils;
